import { copyListFormStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

copyListFormStyles.cancelButton = {
    color: "secondary",
    css: css`
        margin-right: 10px;
        border-color: none;
        background: #ffffff;
        border: 1px solid ${getColor("common.border")};
        border-radius: unset;
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;
            border-color: ${getColor("text.main")} !important;
            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
                border-color: ${getColor("text.accent")} !important;
           
        } */
        }
    `,
};
